import React from "react";
import { useTranslation } from "react-i18next";
import logoWithoutBackground from "../../../assets/images/Liifer_logo_full_max.png";
import { Link, useNavigate } from "react-router-dom";
import { useAppSelector } from "store/hooks";
import burgerImage from "../../../assets/images/burger.webp";

export const SignUpBanner: React.FC = () => {
  const { t } = useTranslation();
  const accessToken = useAppSelector((state) => state.auth.accessToken);
  const navigate = useNavigate();

  return (
    <>
      {!accessToken ? (
        <>
          <div className="text-slate-800 font-medium text-3xl w-full h-fit lg:w-72 bg-slate-300 flex lg:flex-col rounded-xl">
            <div className="pt-6 pb-4 lg:pb-0 px-4 lg:px-6 flex-col justify-start w-full">
              <div
                style={{ backgroundColor: "#171F38" }}
                className="flex flex-row rounded-full w-fit"
              >
                <img
                  className="h-9 m-3 mx-5"
                  src={logoWithoutBackground}
                  alt="Liifer Logo"
                />
              </div>
              <p className="font-bold text-xl lg:text-2xl leading-normal py-5">
                {t("FAQ.discoverLiiferExperience")}
              </p>
              <button
                className="text-xl font-semibold rounded-full bg-green-500 text-slate-800 px-5 py-2"
                onClick={() => {
                  navigate("/login");
                }}
                type="button"
              >
                {t("form.login")}
              </button>
            </div>
            <div className="flex mr-8 lg:mr-0 lg:pl-6 lg:pb-6 -mt-6">
              <div className="pt-20 w-36 hidden lg:block">
                <p className="text-slate-800 text-lg font-bold">
                  {t("form.newUser")}
                  <Link to={"/signup"} draggable={false}>
                    <div className="text-blue-600 hover:underline cursor-pointer">
                      {t("form.signUpHere")}
                    </div>
                  </Link>
                </p>
              </div>
              <img
                className="w-40 lg:w-28 h-auto object-contain"
                src={burgerImage}
                alt="Burger"
              />
            </div>
          </div>
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default SignUpBanner;
